
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"facturacionMasivaCola"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itemsPerPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDesc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FacturacionMasivaFiltersInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facturacionMasivaCola"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageNumber"}}},{"kind":"Argument","name":{"kind":"Name","value":"itemsPerPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itemsPerPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderDesc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDesc"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordenVentaId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numeroOrdenVenta"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"movimientoId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clienteId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clienteRazonSocial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clienteCondicionIVA"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tipoComprobante"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vendedorNombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depositoNombre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precioTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fecha"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estado"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estadoPago"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estadoFacturacion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apto"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"motivo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"totalItems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"page"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalPages"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"empresaValida"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"empresaError"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":753}};
    doc.loc.source = {"body":"query facturacionMasivaCola(\n  $pageNumber: Int\n  $itemsPerPage: Int\n  $search: String\n  $orderBy: String\n  $orderDesc: Boolean\n  $filters: FacturacionMasivaFiltersInput\n) {\n  facturacionMasivaCola(\n    pageNumber: $pageNumber\n    itemsPerPage: $itemsPerPage\n    search: $search\n    orderBy: $orderBy\n    orderDesc: $orderDesc\n    filters: $filters\n  ) {\n    items {\n      ordenVentaId\n      numeroOrdenVenta\n      movimientoId\n      clienteId\n      clienteRazonSocial\n      clienteCondicionIVA\n      tipoComprobante\n      vendedorNombre\n      depositoNombre\n      precioTotal\n      fecha\n      estado\n      estadoPago\n      estadoFacturacion\n      apto\n      motivo\n    }\n    totalItems\n    page\n    totalPages\n    empresaValida\n    empresaError\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["facturacionMasivaCola"] = oneQuery(doc, "facturacionMasivaCola");
        
